import { render } from "./SittingModule.vue?vue&type=template&id=18c79f83&scoped=true"
import script from "./SittingModule.vue?vue&type=script&lang=js"
export * from "./SittingModule.vue?vue&type=script&lang=js"

import "./SittingModule.vue?vue&type=style&index=0&id=18c79f83&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c79f83"]])

export default __exports__